const formatPhoneNumber = (number) => {
    if (typeof number !== "string") return number;
    const cleaned = number.replace(/\D/g, "");
    if (cleaned.length > 0) {
        if (cleaned.charAt(0) === "0") {
            return `+[country code] ${cleaned}`;
        } else if (cleaned.charAt(0) !== "+") {
            return `+${cleaned}`;
        }
        return `+${cleaned}`;
    }
    return number;
};

const formatForDisplay = (number) => {
    if (typeof number !== "string") return number;
    const cleaned = number.replace(/\D/g, "");
    if (cleaned.length > 0) {
        if (cleaned.length > 7) {
            let countryCode = cleaned.substring(0, 3); 
            let restOfNumber = cleaned.substring(3);
            let formattedRest = "";
            for (let i = 0; i < restOfNumber.length; i += 3) {
                formattedRest += restOfNumber.substring(i, i + 3);
            }
            return `${countryCode}${formattedRest.trim()}`;
        }
    }
    if (number.charAt(0) !== "+" && number.length > 0) {
        return `${number}`;
    }
    return number;
};

function formatKeyName(input) {
    const words = input.split("_");
    const formattedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return formattedWords.join(" ");
}

const NODES = [
    "WELCOME",
    "START",
    "PERSONAL_INFO",
    "PERSONAL_INFO_SUBMIT",
    "POLICY_MGT_MENU",
    "POLICY_NOT_FOUND",
    "POLICY_STATUS",
    "PREMIUM_TYPES",
    "CORPORATES_FARMERS_TRADERS",
    "SSB_ZNA_PENSIONERS",
    "PLAN_DETAILS",
    "PAYMENT_HISTORY",
    "POLICY_DETAILS",
    "POLICY_NUMBER",
    "DEPENDENTS_CHECK", 
    "UPDATE_POLICY",
    "POLICY_BENEFITS",
    "PRODUCT_LIST",
    "PRODUCT_DETAILS",
    "CASH_FUNERAL",
    "PAYMENT_OPTIONS",
    "PAYNOW",
    "ECOCASH",
    "BANCABC",
    "DOVES_MOBILE_APP",
    "APPLY_FOR_POLICY",
    "CONTACT_DETAILS_CONSULTANT",
    "CONTACT_DETAILS",
    "DOVES_CONSULTANT",
    "BRANCHES",
    "FAQS_SERVICE_FEEDBACK",
    "SERVICE_FEEDBACK",
    "FAQS",
    "LOANS",
    "LOAN_PRODUCTS",
    "LOAN_REQUIREMENTS",
    "POLICY_UPGRADES_ADDONS",
    "POLICY_UPGRADES",
    "POLICY_UPGRADES_CASKET",
    "POLICY_ADDONS",
    "CHOOSE_POLICY_ADDON"
]

export { formatPhoneNumber, formatForDisplay, formatKeyName, NODES };